/**
 * PATH: apps/qa/src/pages/portal/types.ts
 * PURPOSE: Type definitions for the external QA portal
 */

export type PortalPermission = 'review' | 'comment' | 'sign' | 'download'

export interface PortalData {
  revision: {
    id: string
    revision_number: number
    content_hash: string
    issued_at: string
  }
  inspection: {
    id: string
    name: string
    job_id: string | number
  }
  permissions: PortalPermission[]
  expires_at: string
  pdf_available: boolean
  comments: PortalComment[]
  signatures: PortalSignature[]
}

export interface PortalComment {
  id: string
  comment: string
  created_at: string
}

export interface PortalSignature {
  id: string
  signer_name: string
  signer_role?: string
  comment?: string
  created_at: string
  signature_file?: string | null
}

export type PortalFailure = 'invalid' | 'expired' | 'revoked' | 'unavailable'

export interface PortalSignPayload {
  signer_name: string
  signer_email: string
  signer_role?: string
  comment?: string
  signature_file_id?: string | null
}

export class PortalRequestError extends Error {
  constructor(public readonly kind: PortalFailure, message: string) {
    super(message)
  }
}
